import api from "@/lib/api";

// Fire-and-forget: mark a premium feature as sampled for the "Explore Rodeo Pilot"
// checklist. Idempotent server-side; triggers a wallet refresh so the checklist updates.
export function markExplored(feature) {
  api.post("/me/explored", { feature })
    .then(() => window.dispatchEvent(new Event("rp-credits-refresh")))
    .catch(() => {});
}
